import api from "./api";
import {
  TurmaCertificateConfig,
  TurmaCertificadoPesquisaConsolidado,
  TurmaSatisfactionSurveyConfig,
} from "../types/acao";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token nao encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

const getApiErrorMessage = (error: any, fallback: string) => {
  const responseData = error?.response?.data;

  if (responseData?.errors) {
    const firstError = Object.values(responseData.errors)
      .flat()
      .find((message) => typeof message === "string");

    if (typeof firstError === "string" && firstError.trim()) {
      return firstError;
    }
  }

  return (
    responseData?.message || (error instanceof Error ? error.message : fallback)
  );
};

type ApiResponse<T> = {
  success: boolean;
  data: T;
  message?: string;
};

export async function findTurmaCertificadoPesquisa(
  turmaId: string | number,
): Promise<TurmaCertificadoPesquisaConsolidado> {
  try {
    const response = await api.get<
      ApiResponse<TurmaCertificadoPesquisaConsolidado>
    >(`/turmas/${turmaId}/certificado-pesquisa`, {
      headers: getAuthHeaders(),
    });

    return response.data.data;
  } catch (error: any) {
    throw new Error(
      getApiErrorMessage(
        error,
        "Erro ao consultar configuracoes de certificado e pesquisa.",
      ),
    );
  }
}

export async function saveTurmaCertificado(
  turmaId: string | number,
  payload: {
    certificate_template_id: number;
    data_inicio_disponibilizacao: string;
    data_fim_disponibilizacao: string | null;
    hora_inicio_disponibilizacao: string;
    hora_fim_disponibilizacao: string | null;
  },
): Promise<TurmaCertificateConfig> {
  try {
    const response = await api.post<ApiResponse<TurmaCertificateConfig>>(
      `/turmas/${turmaId}/certificado`,
      payload,
      {
        headers: getAuthHeaders(),
      },
    );

    return response.data.data;
  } catch (error: any) {
    throw new Error(
      getApiErrorMessage(error, "Erro ao salvar configuracao de certificado."),
    );
  }
}

export async function deleteTurmaCertificado(
  turmaId: string | number,
): Promise<string> {
  try {
    const response = await api.delete<ApiResponse<null>>(
      `/turmas/${turmaId}/certificado`,
      {
        headers: getAuthHeaders(),
      },
    );

    return (
      response.data.message ||
      "Configuracao de certificado removida com sucesso."
    );
  } catch (error: any) {
    throw new Error(
      getApiErrorMessage(error, "Erro ao remover configuracao de certificado."),
    );
  }
}

export async function saveTurmaPesquisaSatisfacao(
  turmaId: string | number,
  payload: {
    satisfaction_survey_template_id: number;
    obrigatoria_para_certificado: boolean;
  },
): Promise<TurmaSatisfactionSurveyConfig> {
  try {
    const response = await api.post<ApiResponse<TurmaSatisfactionSurveyConfig>>(
      `/turmas/${turmaId}/pesquisa-satisfacao`,
      payload,
      {
        headers: getAuthHeaders(),
      },
    );

    return response.data.data;
  } catch (error: any) {
    throw new Error(
      getApiErrorMessage(
        error,
        "Erro ao salvar configuracao da pesquisa de satisfacao.",
      ),
    );
  }
}

export async function deleteTurmaPesquisaSatisfacao(
  turmaId: string | number,
): Promise<string> {
  try {
    const response = await api.delete<ApiResponse<null>>(
      `/turmas/${turmaId}/pesquisa-satisfacao`,
      {
        headers: getAuthHeaders(),
      },
    );

    return (
      response.data.message ||
      "Configuracao da pesquisa de satisfacao removida com sucesso."
    );
  } catch (error: any) {
    throw new Error(
      getApiErrorMessage(
        error,
        "Erro ao remover configuracao da pesquisa de satisfacao.",
      ),
    );
  }
}
